module.exports = __webpack_public_path__ + "static/flowHeadwinds-3a61b2ae4d3556011021a79f864ff036.png";